import { FolderTree, Settings2 } from "lucide-react";
import { Tabs } from "@shared/ui/tabs"; // Your URL-based tabs component
import { ConnectionsTab } from "../connection/ConnectionsTab";
import { ConnectionsHistory } from "../connection/ConnectionHistory";

interface ConnectionTabProps {
  consumerNo: string;
  consumerID: string;
  remoteUtilityId: string;
}

export const ConnectionLanding: React.FC<ConnectionTabProps> = ({
  consumerNo,
  consumerID,
  remoteUtilityId,
}) => {
  // Configure tabs for URL-based navigation
  const tabComponents = {
    current: {
      label: "Current connection",
      shortLabel: "current",
      icon: <FolderTree size={16} />,
      component: (
        <ConnectionsTab
          consumerNo={consumerNo}
          remoteUtilityId={remoteUtilityId}
        />
      ),
      className: "flex-1", // Maintain grid-like appearance
    },
    history: {
      label: "Allocation history",
      shortLabel: "history",
      icon: <Settings2 size={16} />,
      component: (
        <ConnectionsHistory
          consumerNo={consumerNo}
          consumerID={consumerID}
          remoteUtilityId={remoteUtilityId}
        />
      ),
      className: "flex-1",
    },
  };

  const urlMapping = {
    current: "current",
    history: "history",
  };

  return (
    <div className="space-y-6">
      <Tabs
        defaultValue="current"
        urlMapping={urlMapping}
        tabComponents={tabComponents}
        tabsListClassName="grid w-full grid-cols-2 mb-6"
        idPrefix="complaints-sub-tab"
        className="w-full"
        level={1}
      />
    </div>
  );
};
